document.addEventListener("DOMContentLoaded", function () {
    console.log("✅ Checking if Slick is available...");

    function initializeSlick() {
        let slider = document.querySelector('.custom-slider');
        if (slider && typeof window.$ !== "undefined" && typeof window.$.fn.slick !== "undefined") {
            console.log("✅ Slick is available, initializing slider...");

            window.$(slider).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 3000,
                dots: true,
                arrows: false,
                responsive: [
                    { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                    { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } }
                ]
            });

            console.log("✅ Slick initialized successfully!");
        } else {
            console.warn("⚠️ Slick not found, retrying in 500ms...");
            //setTimeout(initializeSlick, 500); // Keep retrying every 500ms until Slick loads
        }
    }

    initializeSlick();

    // ✅ Shopify Theme Editor Mode Support
    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', initializeSlick);
        document.addEventListener('shopify:section:reorder', initializeSlick);
    }
});
